import { httpsCallable, getFunctions } from "firebase/functions";
import { app } from "../lib/firebase";

// generateContent function อยู่ region asia-southeast1
const functions = getFunctions(app, 'asia-southeast1');

/**
 * เจนคอนเทนต์ในเว็บด้วย Gemini (ผ่าน Firebase Function generateContent)
 * ส่ง prompt → คืนข้อความผลลัพธ์
 */
export const generateWithAI = async (
  prompt: string,
  username?: string,
  temperature?: number,
  images?: { b64: string; mime: string }[] // รูปแนบให้ AI "ดู" ประกอบ (สูงสุด 3)
): Promise<string> => {
  const fn = httpsCallable(functions, 'generateContent', { timeout: 180000 });
  const result = await fn({ prompt, username, temperature, images });
  const text = (result.data as any)?.text;
  if (!text) throw new Error('AI ไม่ได้สร้างเนื้อหา กรุณาลองใหม่');
  return text as string;
};

/**
 * เจนภาพด้วย Gemini Flash Image (nano-banana) — refImageB64 = รูปอ้างอิงตัวละคร (ให้หน้าเดิมทุกภาพ)
 * คืน { imageB64, mime }
 */
export const generateImageAI = async (
  prompt: string,
  refImageB64?: string,
  refMime?: string,
  username?: string
): Promise<{ imageB64: string; mime: string }> => {
  const fn = httpsCallable(functions, 'generateImage', { timeout: 180000 });
  const result = await fn({ prompt, refImageB64, refMime, username });
  const d = result.data as any;
  if (!d?.imageB64) throw new Error('AI ไม่ได้สร้างภาพ กรุณาลองใหม่');
  return { imageB64: d.imageB64, mime: d.mime || 'image/png' };
};
